import Icon from "@components/global/new/Icon/Icon";
import Title from "@components/global/new/Title/Title";
import { localeMiningDays3 } from "@utils/localeMiningDays";
import cn from "classnames";
import { memo, useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { usePlanCreatorContext } from "@components/PlanCreator/PlanCreatorContext";
import { dev } from "@utils/dev";
import { Tooltip } from "antd";
import styles from "./PeriodsTitle.module.scss";

interface IPeriodsTitleVm {
  readonly days: string[];
  readonly showTooltip: boolean;
  readonly hasDay: boolean;
}

const SLICE = 3;

function PeriodsTitle(): JSX.Element {

  const { formatMessage } = useIntl();
  const {
    disabled,
    currentDay,
    selectedDays
  } = usePlanCreatorContext();

  const [viewModel, setViewModel] = useState<IPeriodsTitleVm>(() => ({
    days: [],
    showTooltip: false,
    hasDay: false,
  }));

  useEffect(() => {
    const sorted = selectedDays?.sort((a, b) => Number(a) - Number(b));
    setViewModel({
      days: sorted,
      showTooltip: sorted && sorted.length > SLICE && !disabled,
      hasDay: currentDay !== undefined || selectedDays.length > 0,
    });
  }, [disabled, currentDay, selectedDays]);


  return (
    <div className={styles.title_wrapper}>
      <Title className={styles.wrapper}>
        {viewModel.hasDay && (
          <>
            <Tooltip
              open={viewModel.showTooltip ? undefined : false}
              placement='top'
              color='#fff'
              trigger={"hover"}
              title={
                <div className={styles.days} style={{ color: "#000" }}>
                  {viewModel.days.map((d) => localeMiningDays3(d)).join(", ")}
                </div>
              }
            >
              {viewModel.days.length > 0 ? (
                <span className={cn(styles.day)}>
                  {viewModel.days
                    .slice(0, SLICE)
                    .map((d) => localeMiningDays3(d))
                    .join(", ") + `${viewModel.showTooltip ? "..." : ""}`}
                </span>
              ) : (
                <span className={cn(styles.day)}>
                  {localeMiningDays3(currentDay?.day || "")}
                </span>
              )}{" "}
            </Tooltip>
          </>
        )}
        {formatMessage({ id: "modal.create_plan.plan.except" })}
      </Title>
    </div>
  );
}

export default memo(PeriodsTitle);